import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { ThemeProvider } from "./components/ui/theme-provider"
import { Toaster } from "./components/ui/toaster"
import { Layout } from "./components/Layout"
import { HomePage } from "./pages/HomePage"
import { BetaPage } from "./pages/BetaPage"
import { DemoPage } from "./pages/DemoPage"
import { ContactPage } from "./pages/ContactPage"
import { RequestPage } from "./pages/RequestPage"
import { RegisterPage } from "./pages/RegisterPage"
import { LoginPage } from "./pages/LoginPage"
import CareersApplicationForm from "@/components/careers/CareersApplicationForm"

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="ui-theme">
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="beta" element={<BetaPage />} />
            <Route path="demo" element={<DemoPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="request" element={<RequestPage />} />
            <Route path="careers" element={<CareersApplicationForm />} />
          </Route>
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
      </Router>
      <Toaster />
    </ThemeProvider>
  )
}

export default App